module.exports = {
    devices_main_cast_import_manual: "Import Geometris from Cast",
    castImportManual_title: "Import Geometris from Cast (Manual)",
    castImportManual_description: "Enter up to 300 ESNs (one per line or comma-separated) to import them from CAST.",
    castImportManual_placeholder: "ESN1\nESN2\nESN3...",
    castImportManual_esns_entered: "ESNs entered",
    castImportManual_max_exceeded: "You can enter a maximum of 300 ESNs per import.",
    castImportManual_import: "Import",
    castImportManual_cancel: "Cancel",
    castImportManual_success: "Import process started. Click to view the transaction.",
    castImportManual_error: "An error occurred while starting the import. Please try again.",
};
